// Shared contract for Help Center article blocks (Article Templates).
// A block is stored inside the article HTML as an inert placeholder:
//   <div class="hc-block" data-hc-block="<type>" data-hc-config="<base64 JSON>"></div>
// The config is DATA ONLY — never executable code — validated server-side by
// HelpCenter::BlockSchema and rendered by shared Vue components (no v-html of
// arbitrary markup). These constants are the single source of truth shared by
// the dashboard editor (insert UI) and the public portal (hydration island).

export const HC_BLOCK_ATTR = 'data-hc-block';
export const HC_CONFIG_ATTR = 'data-hc-config';
export const HC_BLOCK_CLASS = 'hc-block';

// Block types. Mirrors HelpCenter::BlockSchema::BLOCK_TYPES (Ruby).
export const HC_BLOCK_TYPES = {
  ACCORDION: 'accordion',
  CAROUSEL: 'carousel',
  GALLERY: 'gallery',
  TABLE: 'table',
  IMAGE_ZOOM: 'imageZoom',
  CARDS: 'cards',
  BANNER: 'banner',
  GRID: 'grid',
};

// Table block: row count above which pagination turns on automatically when
// the admin leaves "pagination" on Auto. Mirrors tableMixin.js.
export const TABLE_AUTO_PAGINATION_THRESHOLD = 10;

// Table block: fixed set of selectable page sizes, shown in the admin's
// "Rows per page" dropdown.
export const TABLE_PAGE_SIZE_OPTIONS = [10, 25, 50, 100];

// UTF-8 safe base64 so any language (accents, CJK) survives the round-trip
// through an HTML attribute without breaking on quotes.
export function encodeBlockConfig(config) {
  const json = JSON.stringify(config || {});
  return btoa(
    encodeURIComponent(json).replace(/%([0-9A-F]{2})/g, (_, hex) =>
      String.fromCharCode(parseInt(hex, 16))
    )
  );
}

export function decodeBlockConfig(encoded) {
  if (!encoded) return {};
  try {
    const json = decodeURIComponent(
      Array.prototype.map
        .call(
          atob(encoded),
          c => `%${`00${c.charCodeAt(0).toString(16)}`.slice(-2)}`
        )
        .join('')
    );
    const parsed = JSON.parse(json);
    return parsed && typeof parsed === 'object' ? parsed : {};
  } catch (error) {
    return {};
  }
}

// Only http(s) and root-relative links are safe to place in href/src. Anything
// else (javascript:, data:, etc.) is dropped, mirroring the Ruby sanitizer.
export function safeUrl(value) {
  if (typeof value !== 'string') return '';
  const candidate = value.trim();
  return /^(https?:\/\/|\/)/.test(candidate) ? candidate : '';
}
